import { cn } from "@/utils/cssHelpers";
import { RadioGroup } from "@headlessui/react";
import React from "react";

export type CaColorPickerProps = {
  colors: string[] | Record<string, string>;
  onChange: (color: string) => void;
  value: string;
};

function CaColorPicker({ colors, onChange, value }: CaColorPickerProps) {
  const isRecord = !Array.isArray(colors);
  const list = isRecord ? Object.values(colors) : colors;
  const keys = isRecord ? Object.keys(colors) : colors;

  return (
    <RadioGroup value={value} onChange={onChange} className='flex gap-2 items-center justify-start'>
      {list.map((color, index) => (
        <RadioGroup.Option key={index} value={keys[index]}>
          {({ checked }) => (
            <div
              className={cn(
                "w-9 h-9 rounded-full p-1 flex justify-center items-center border border-transparent",
                checked && "border-purple",
              )}
            >
              <span
                className={cn("w-full h-full rounded-full shadow-sm border border-gray-200")}
                style={{ backgroundColor: color }}
              ></span>
            </div>
          )}
        </RadioGroup.Option>
      ))}
    </RadioGroup>
  );
}

export default CaColorPicker;
